import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
// @ts-ignore
import Quagga from "quagga"

@Component({
  selector: 'app-barcode',
  templateUrl: './barcode.component.html',
  styleUrls: ['./barcode.component.scss']
})
export class BarcodeComponent {

  @ViewChild('video') videoElement: ElementRef | undefined;
  code: string='';
  private lastReadings: string[] = [];

  constructor(public dialogRef: MatDialogRef<BarcodeComponent>){

 

  }

  ngOnInit(): void {
    this.lastReadings=[];
    this.dialogRef.backdropClick().subscribe(() => {
      console.log('Modal cerrado al hacer clic fuera');
      Quagga.stop();
    const videoElement: HTMLVideoElement = this.videoElement?.nativeElement;
    const mediaStream = videoElement.srcObject as MediaStream;

    if (mediaStream) {
      const tracks = mediaStream.getTracks();

      tracks.forEach(track => {
        track.stop();
      });

      videoElement.srcObject = null;
    }
    });
  }

  ngAfterViewInit() {
    const videoElement: HTMLVideoElement = this.videoElement?.nativeElement;
    navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } })
      .then((stream) => {
        videoElement.srcObject = stream;
        this.scanBarcode();
      })
      .catch((err) => {
        console.error('Error al acceder a la cámara: ', err);
      });
  }


  scanBarcode() {
    Quagga.init({
      inputStream: {
        name: "Live",
        type: "LiveStream",
        target: this.videoElement?.nativeElement
      },
      decoder: {
        readers: ["code_128_reader"] 
      }
    }, (err:any) => {
      if (err) {
        console.error('Error al inicializar Quagga: ', err);
        return;
      }
      Quagga.start();
      Quagga.onDetected((data:any) => {
        console.log('Código de barras escaneado:', data.codeResult.code);
        this.code = data.codeResult.code;
        this.lastReadings.push(this.code);

        var ocurrencias= this.lastReadings.filter(item => item === this.code).length;

        if(ocurrencias>4){

          this.lastReadings=[];
          this.close();
        }

        
      });
    });
  }

  



  close(){
    Quagga.stop();
    const videoElement: HTMLVideoElement = this.videoElement?.nativeElement;
  const mediaStream = videoElement.srcObject as MediaStream;

  if (mediaStream) {
    const tracks = mediaStream.getTracks();

    tracks.forEach(track => {
      track.stop();
    });

    videoElement.srcObject = null;
  }

  this.dialogRef.close(this.code);
  
  }

}
